import $axios from 'axios'
import {
    cardInfoUri,
    sendMsgUri
} from '../config/uri'

//获取卡片信息接口
export function getCardInfo(data) {
    return $axios.post(cardInfoUri, data)
}
//消息
export function sendRongCloudmsg(data) {
    return $axios.post(sendMsgUri, data)
}